<template>
<div class="animated fadeIn">

  <b-card no-body>
    <b-card-body v-if="!showVisitForm">
       <b-row>
         <b-col>
            <h1 variant="primary">Please Scan AadharCard</h1>
         </b-col>
       </b-row>
       <b-row>
        <b-col>
        <b-form-group label="" label-for="qrCodeInput">
         <b-form-input id="qrCodeInput" ref="qrCodeInput" v-model="qrCode" v-on:keyup.enter="processScannedCard" autofocus></b-form-input>
        </b-form-group>
        </b-col>
       </b-row>
     
    </b-card-body>
  </b-card>
  <aadhar-card-information   :aadharCardInfo="scanedCard"  @success="newEntrySuccess" @cancel="cancelNewEntry"  />


</div>

</template>


<script>
import Vue from 'vue'
import AadharCardInformation from './AadharCardInformation'

import XmlToJson from './xmlToJson.js'

export default {
name: 'AadharCardScan',
components: {
  AadharCardInformation,


},

data: function() {
  return {
    scanedCard :{},
    qrCode: "",
    showVisitForm: false
  }
},

methods: {
  newEntrySuccess(){
    //  this.$refs.modalAadharCard.hide();
      this.scanedCard = null;
      this.showVisitForm = false;
      this.$refs.qrCodeInput.$el.focus()

  },
  hideAadharCardModal() {
    this.scanedCard = null;
    showDismissibleAlert = false;
    this.$refs.modalAadharCard.hide();
    this.$refs.qrCodeInput.$el.focus()

  },

  openModal() {
    this.scanedCard = null;
    this.showVisitForm = true;
  //  this.$refs.modalAadharCard.show()
  },
  transform(xml) {
    var parser = new XmlToJson();
    var json = parser.parse(xml);
    return json;
  },

  processScannedCard(){
    var scannedQrCode = this.qrCode;
    console.log(scannedQrCode);
    var cardInfo =this.transform(scannedQrCode);


    if(Object.keys(cardInfo).length > 0 ){
        this.scanedCard = {
                uid: cardInfo.PrintLetterBarcodeData.uid,
                name:  cardInfo.PrintLetterBarcodeData.name,
                gender:  cardInfo.PrintLetterBarcodeData.gender,
                yob:  cardInfo.PrintLetterBarcodeData.yob,
                gname:  cardInfo.PrintLetterBarcodeData.gname,
                co:  cardInfo.PrintLetterBarcodeData.co,
                loc:  cardInfo.PrintLetterBarcodeData.loc,
                vtc:  cardInfo.PrintLetterBarcodeData.vtc,
                po:  cardInfo.PrintLetterBarcodeData.po,
                dist:  cardInfo.PrintLetterBarcodeData.dist,
                subdist:  cardInfo.PrintLetterBarcodeData.subdist,
                state:  cardInfo.PrintLetterBarcodeData.state,
                pc:  cardInfo.PrintLetterBarcodeData.pc,
                dob:  cardInfo.PrintLetterBarcodeData.dob
        };
        this.showVisitForm = true;


    }

  },



  cancelNewEntry(){
    this.scanedCard = null;
    this.showVisitForm = false;
    this.$refs.qrCodeInput.$el.focus()

  },




},
mounted(){
  this.$refs.qrCodeInput.$el.focus()
},

created () {

},
destroyed () {

},


}

</script>
